"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsLogoutModalOpen = exports.dialogModalSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    isLogoutModalOpen: false,
};
exports.dialogModalSlice = (0, toolkit_1.createSlice)({
    name: 'dialogModal',
    initialState,
    reducers: {
        setIsLogoutModalOpen: (state, action) => {
            state.isLogoutModalOpen = action.payload;
        }
    }
});
exports.setIsLogoutModalOpen = exports.dialogModalSlice.actions.setIsLogoutModalOpen;
exports.default = exports.dialogModalSlice.reducer;
